/**
 * @generated SignedSource<<25b51359b03e05978460bcc57efa2d1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemGeneratorDeactivateDialog_problemGenerator$data = {
  readonly id: string;
  readonly " $fragmentType": "ProblemGeneratorDeactivateDialog_problemGenerator";
};
export type ProblemGeneratorDeactivateDialog_problemGenerator$key = {
  readonly " $data"?: ProblemGeneratorDeactivateDialog_problemGenerator$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorDeactivateDialog_problemGenerator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProblemGeneratorDeactivateDialog_problemGenerator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProblemGenerator",
  "abstractKey": null
};

(node as any).hash = "75b111dc3e217e77e9049fe636d1486b";

export default node;
